<script> 
  import Alert from "./Alert.svelte";  
  import axios from "axios"; 
  import Load from "./Load.svelte";
  import Modal from "./Modal.svelte";
  let settings = {
      url: "https://api.dekatan.com"
    }; 
let alert = [];  
  let areaawal = "";
let areaawalinput = "";
  if (localStorage["area"]) {
    areaawal = localStorage["area"];
  }
  let area = areaawal;
  $: if (localStorage["area"]) {
    localStorage["area"] = area;
  } else {
    localStorage["area"] = area;
  }

  if (localStorage["inputarea"]) {
    areaawalinput = localStorage["inputarea"];
  }
  let inputarea = areaawalinput;
  $: if (localStorage["inputarea"]) {
    localStorage["inputarea"] = inputarea;
  } else {
    localStorage["inputarea"] = inputarea;
  }

  
  let inputarea_selected = "Tentukan Lokasi Saat Ini";
  let inputarea_notif = true;
  
 if (localStorage["area_selected"]) { 
    inputarea_selected = localStorage["area_selected"];
    if (localStorage["area"]) { 
    inputarea_notif = false;
    }else {      
    inputarea_notif = true;
    }
 }else {
    inputarea_selected = "Tentukan Lokasi Saat Ini";
 }

 function resetDesa(){ 
window.localStorage.removeItem('area_selected');
inputarea_selected = "Tentukan Lokasi Saat Ini";
window.localStorage.removeItem('area');
window.localStorage.removeItem('inputarea');
  window.location.reload()
 }
  function areaUpdate(selected){
 if (localStorage["area_selected"]) { 
    localStorage.setItem("area_selected", selected); 
  } else { 
    localStorage.setItem("area_selected", selected); 
  }
  
  window.location.reload()
  } 

let loading = false;
let items = [];
  function cariDesa() {
    loading = true;
    if (inputarea.length > 2) {
      axios
        .get(settings.url + "/publik/desa/" + inputarea)
        .then(function (response) {
          items = response.data.list;
          loading = false;
        })
        .catch(function (error) {
          loading = false;
          
          alert = [
            ...alert,
            {
              title: "Dekatan",
              message: "Anda belum terhubung dengan baik",
              color: "orange",
            },
          ];
        });
    } else {
      loading = false;
      alert = [
        ...alert,
        {
          title: "Dekatan",
          message: "Ketik setidaknya 3 huruf untuk mencari desa",
          color: "orange",
        },
      ]; 
    }
  }


  function loadingBtn(e) {
    let el = this;
    el.setAttribute("disabled", "disabled");
    let reset = e.srcElement.innerHTML;
    this.innerHTML = "Memproses...";
    setTimeout(() => {
      el.innerHTML = reset;
      el.removeAttribute("disabled");
    }, 10000);
  }
</script>

{#if alert.length > 0}
  <div class="fixed bottom-0 right-0 z-50 w-full px-2 mx-auto mb-10 lg:w-auto">
    {#each alert as a}
      <Alert color={a.color} title={a.title} message={a.message} />
    {/each}
  </div>
{/if}


<Modal backdropClose size="lg:w-2/5 w-full z-50">
    <div class="flex w-full gap-2" slot="trigger" let:open>
      {#if inputarea_notif} 
      <button
        on:click={open}
        class="flex items-center w-full gap-2 px-2 py-1 text-sm font-bold bg-white border border-gray-200 rounded shadow outline-none pointer-events-auto md:focus:border-blue-600"
        title="{inputarea_selected}"> 
        <span class="flex w-6 h-6"><span class="absolute inline-flex w-6 h-6 bg-gray-400 rounded-full opacity-75 animate-ping"></span> <span class="relative inline-flex w-6 h-6 overflow-hidden rounded-full"><img src="./assets/svg/gps.svg" width="27px" alt="gps"></span></span> <div class="font-light text-left text-gray-700 ellipsis-1">{inputarea_selected}</div>
       
      </button>
      {:else}
      
      <button
        on:click={open}
        class="flex items-center w-full gap-2 px-2 py-1 text-sm font-bold bg-white border border-gray-200 rounded shadow outline-none pointer-events-auto md:focus:border-blue-600"
        title="{inputarea_selected}"> 
        <span class="flex w-6 h-6"><span class="absolute inline-flex w-6 h-6 rounded-full opacity-75"></span> <span class="relative inline-flex w-6 h-6 overflow-hidden rounded-full"><img src="./assets/svg/gps.svg" width="27px" alt="gps"></span></span> <div class="font-light text-left text-gray-700 ellipsis-1">{inputarea_selected}</div>
       
      </button>
      
      {/if}
      <a href="/pencarian" class="flex items-center px-2 text-xs border border-gray-300 rounded-md shadow lg:hidden md:flex focus:outline-none"><span class="w-24 font-light text-gray-400 ellipsis-1">Cari Produk...</span> <img src="./assets/svg/search.svg" alt="search" class="inline-block w-4 h-4 m-1 lg:hidden" width="17" height="17"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" class="hidden w-2 h-2 m-1 lg:w-4 lg:h-4 lg:inline-block"><path d="M12 12l8-8V0H0v4l8 8v8l4-4v-4z"></path></svg></a>
    </div>

    <div slot="header">
      <h1 class="text-lg">
        Tentukan Area Anda Saat Ini
      </h1> 
    </div>
    <div slot="content" class="h-full"> 
  
        <div class="w-full rounded-lg lg:px-2">
            {#if loading}
            <Load />
          {/if}
            <form
                        autocomplete="off"
                        class="w-full"
                        on:submit|preventDefault={cariDesa}>
                        <div class="px-2 pb-2">
                          <div class="w-full mb-2">
                            <section class="mt-5">
                              <label for="area" class="relative block text-sm font-light">
                                <input
                                  id="area"
                                  type="text"
                                  class="w-full text-lg placeholder-gray-400 border-gray-500 form-input hover:border-blue-400 focus:shadow-none"
                                  placeholder="Ketik Nama Desa Disini, ex : Tamansari"
                                  name="area"
                                  autocomplete="off"
                                  bind:value={inputarea} />
                                <span
                                  class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                                  id="area-labelwarning">Ketik nama Desa lalu klik CARI</span>
                                <span
                                  class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                                  id="area-warning" />
                              </label>
                            </section> 

                          </div>
                          <button
                            type="button"
                            class="w-full px-5 py-2 text-gray-100 bg-green-600 rounded-lg text-1xl focus:bg-gray-500 focus:outline-none"
                            on:click={cariDesa}
                            on:click={loadingBtn}>
                            CARI
                          </button>
                          <button
                            type="button"
                            class="w-full px-5 py-2 mt-2 text-gray-100 bg-orange-500 rounded-lg text-1xl focus:bg-gray-500 focus:outline-none"
                            on:click={resetDesa}
                            on:click={loadingBtn}>
                            TANPA SET AREA
                          </button>
                        </div>
                      </form>
                      <div class="h-auto pb-10">
                        {#if items}
                          {#each items as d, i}
                            <a
                              href
                              on:click|preventDefault 
                              on:click={() => (area = d.kode)}
                              on:click={() => areaUpdate(d.desa+ " "+ d.kec+" "+d.kab)}
                              on:click={() => (inputarea_selected = d.desa+ " "+ d.kec+" "+d.kab)}
                              on:click={() => document.getElementsByClassName("backdrop")[0].click()}
                              
                              class="block w-full px-4 py-3 my-3 bg-gray-100 rounded-md shadow cursor-pointer hover:bg-white hover:shadow-outline">
                              <div class="flex items-center justify-between text-left">
                                <span class="text-base text-gray-800">
                                  <b>{d.desa}</b>
                                  -
                                  {d.kode}
                                  <br />
                                  {d.kec}
                                  {d.kab}
                                </span>
                                <span
                                  class="px-3 py-1 font-bold text-gray-100 bg-gray-400 rounded-lg">
                                  &gt;
                                </span>
                              </div>
                            </a>
                          {/each}
                        {:else}
                          <div 
                            class="w-full lg:w-auto">
                            <div
                              class="w-full p-2 mx-auto mb-2 text-xs bg-orange-300 border-4 border-t border-b border-r border-orange-600 border-solid rounded shadow-lg lg:w-auto color-white">
                              <h2 class="text-sm font-bold">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 20 20"
                                  class="inline-block w-5 h-5">
                                  <path
                                    d="M4 8a6 6 0 0 1 4.03-5.67 2 2 0 1 1 3.95 0A6 6 0 0
                                    1 16 8v6l3 2v1H1v-1l3-2V8zm8 10a2 2 0 1 1-4 0h4z" />
                                </svg>
                                Oops..
                              </h2>
                              <p>
                                Tidak menemukan data, silahkan coba kata kunci lain...
                              </p>
                            </div>
                          </div>
                        {/if}
                      </div>
            </div>
    </div>
  </Modal>

  